import React, { useContext } from 'react';
import { Spinner } from "../../Spinner";
import { LoadingIcon } from "../../../internal/icons2022/LoadingIcon";
import { isTheme2022 } from "../../../lib/theming/ThemeHelpers";
import { ThemeContext } from "../../../lib/theming/ThemeContext";
import { ButtonDataTids } from "../Button";
import { styles } from "../Button.styles";
export var LoadingButtonIcon = function LoadingButtonIcon(_ref) {
  var size = _ref.size,
      _ref$isCentered = _ref.isCentered,
      isCentered = _ref$isCentered === void 0 ? true : _ref$isCentered;
  var theme = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement("div", {
    "data-tid": ButtonDataTids.spinner,
    className: isCentered ? styles.loading() : undefined
  }, isTheme2022(theme) ? /*#__PURE__*/React.createElement(LoadingIcon, {
    size: size
  }) : /*#__PURE__*/React.createElement(Spinner, {
    caption: null,
    dimmed: true,
    type: "mini"
  }));
};